import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { UnreadSmsCountResponse } from '../types';
import { UNREAD_SMS_COUNT } from './constants';

const useGetUnreadSmsCount = () => {
    const req = useRequest();

    const request = React.useCallback(() => {
        return req<UnreadSmsCountResponse>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/sms/unread-count/`
        });
    }, [req]);

    return useQuery({
        queryFn: request,
        queryKey: [UNREAD_SMS_COUNT]
    });
};

export default useGetUnreadSmsCount;
